import blogPostsMetadata from './blogPostsMetadata.json';

// Function to fetch markdown content
const fetchMarkdownContent = async (path) => {
  try {
    const response = await fetch(path);
    return await response.text();
  } catch (error) {
    console.error(`Error fetching markdown from ${path}:`, error);
    return '';
  }
};

// Fetch all blog posts content
const fetchAllBlogPosts = async () => {
  const posts = await Promise.all(
    blogPostsMetadata.map(async (post) => {
      const content = await fetchMarkdownContent(post.contentPath);
      return {
        ...post,
        content
      };
    })
  );
  return posts;
};

// Export the blog posts
export const blogPosts = await fetchAllBlogPosts(); 